<!--
	Some user provided input was incorrect, incorrect fields are highlighted.
-->
<template>
	<session-message :from="item" />
</template>
<script lang="ts">
import { Component, toNative } from "vue-facing-decorator";
import { MiaPlaza } from "../../../Reinforced.Typings";
import SessionMessage from "./SessionMessage.vue";
import { Notification } from "./Shared/Notification";

@Component({
	components: { SessionMessage },
})
export class ValidationError extends Notification<MiaPlaza.Control.Vue.Notifications.IValidationError> {
	get item(): MiaPlaza.Control.Vue.Notifications.ISessionMessage {
		return {
			...this.from,
			Template: "SessionMessage",
			Type: MiaPlaza.Control.Vue.Notifications.SessionMessageType.Error,
		} as MiaPlaza.Control.Vue.Notifications.ISessionMessage;
	}

	protected mounted(): void {
		for (const id of this.from.AffectedControls) {
			const control = document.getElementById(id);
			if (control != null) {
				control.classList.add("has-error");
			}
		}
	}
}

export default toNative(ValidationError);
</script>
